module.exports = __webpack_public_path__ + "img/hanfu-2.75827480.jpg";